"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualizedDropdown = exports.TieredDropdown = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _reactVirtualizedSelect = _interopRequireDefault(require("react-virtualized-select"));
var _classnames = _interopRequireDefault(require("classnames"));
var _select_global_styles = _interopRequireDefault(require("./select_global_styles"));
require("react-virtualized-select/styles.css");
var _chip = require("../chip");
var _utils = require("./utils");
var _option_group_menu_renderer = require("./option_group_menu_renderer");
var _virtualized_select_option_renderer = require("./virtualized_select_option_renderer");
var _excluded = ["optionRenderer"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // @ts-expect-error - TS7016 - Could not find a declaration file for module 'react-select'. 'node_modules/react-select/lib/index.js' implicitly has an 'any' type.
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'react-virtualized-select'. 'node_modules/react-virtualized-select/dist/commonjs/index.js' implicitly has an 'any' type.
// @ts-expect-error - TS7016 - Could not find a declaration file for module './virtualized_select_option_renderer'. 'src/azalea/components/dropdown_resources/virtualized_select_option_renderer.js' implicitly has an 'any' type.
var defaultProps = {
  noResultsText: 'No matches found',
  loadingPlaceholder: 'Loading...,',
  searchPromptText: 'Type to search...'
};
var LegacyDropdown = function LegacyDropdown(props) {
  var onFilterChange = function onFilterChange(options, filter, currentValues) {
    // filterOptions will mutate our original options, so we much copy them first
    var deepCopyOptions = (0, _utils.copyOptions)(options);
    deepCopyOptions = (0, _utils.fixKeys)(deepCopyOptions);
    return (0, _utils.filterOptions)(deepCopyOptions, filter, currentValues);
  };
  var newProps = function newProps() {
    var newPropsOptions = _objectSpread(_objectSpread({}, props), {}, {
      filterOptions: onFilterChange,
      menuRenderer: (0, _option_group_menu_renderer.buildOptionGroupRenderer)({
        allowCategorySelection: true,
        selectedOptions: props.value,
        // remove from list if isMulti in order to make all parent's children disappear if the parent was selected
        removeSelected: props.isMulti,
        noResultsText: props.noResultsText
      }),
      removeSelected: props.isMulti,
      clearable: props.isClearable,
      searchable: props.isSearchable,
      multi: props.isMulti,
      className: (0, _classnames["default"])(props.className, 'legacy-select'),
      disabled: props.isDisabled,
      valueComponent: props.isMulti ? renderOptionsAsChips : undefined
    });
    return newPropsOptions;
  };
  var renderOptionsAsChips = function renderOptionsAsChips(config) {
    // we only care about custom rendering the "chips" or multi-select values
    // if not, use the default renderer

    // you *need* to bind them to onMouseDown
    // because when you click on an item
    // react-select opens the menu and kills the event propagation
    var onMouseDown = function onMouseDown(evt) {
      // prevent react-select from opening the menu on click
      evt.stopPropagation();
      if (!config.disabled) {
        if (config.onClick) {
          config.onClick(evt);
        }
        if (config.onRemove) {
          config.onRemove(config.value);
        }
      }
    };
    var label = config.value.label;
    return /*#__PURE__*/React.createElement(_chip.Chip, {
      key: config.key,
      text: label,
      onRemove: onMouseDown,
      status: "default"
    });
  };
  if (props.isVirtualized) {
    /* passed in optionRenderer must properly handle highlighting selected & focused values properly as virtualizedSelectOptionRenderer does */
    var _newProps = newProps(),
      optionRenderer = _newProps.optionRenderer,
      rest = (0, _objectWithoutProperties2["default"])(_newProps, _excluded);
    return /*#__PURE__*/React.createElement(_reactVirtualizedSelect["default"], (0, _extends2["default"])({}, rest, {
      optionRenderer: optionRenderer || _virtualized_select_option_renderer.virtualizedSelectOptionRenderer
    }));
  } else {
    return /*#__PURE__*/React.createElement(_reactSelect["default"], newProps());
  }
};
var TieredDropdown = exports.TieredDropdown = function TieredDropdown(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_select_global_styles["default"], null), /*#__PURE__*/React.createElement(LegacyDropdown, (0, _extends2["default"])({}, props, {
    isTiered: true,
    isVirtualized: false
  })));
};
var VirtualizedDropdown = exports.VirtualizedDropdown = function VirtualizedDropdown(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_select_global_styles["default"], null), /*#__PURE__*/React.createElement(LegacyDropdown, (0, _extends2["default"])({}, props, {
    isTiered: false,
    isVirtualized: true
  })));
};
LegacyDropdown.defaultProps = defaultProps;

// Do not use these dropdowns directly, use Dropdown in dropdown_select with isTiered or isVirtualized